import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DoctorAppointment } from 'src/app/entities/appointment.entity/doctor-appointment.entity/doctor-appointment';
import { DoctorPrescription } from 'src/app/entities/prescription.entity/doctor-prescription.entity/doctor-prescription';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';

export interface PrescriptionFormValidity {
  medics: boolean;
  radiologies: boolean;
  biologies: boolean;
}

@Component({
  selector: 'app-prescription-form',
  templateUrl: './prescription-form.component.html',
  styleUrls: ['./prescription-form.component.css']
})
export class PrescriptionFormComponent implements OnInit {
  @Input() prescription: DoctorPrescription = new DoctorPrescription();
  @Output() prescriptionChange: EventEmitter<DoctorPrescription> = new EventEmitter();

  @Input() appointment: DoctorAppointment = new DoctorAppointment();
  @Input() submitted: boolean = false;
  @Input() model: boolean = false;
  @Output() tabChange: EventEmitter<{ index: number, label: string }> = new EventEmitter();

  @Input() open: boolean = false;
  @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  private _tabIndex: number = 0;
  label: string = '';

  validity: PrescriptionFormValidity = {
    medics: true,
    radiologies: true,
    biologies: true
  };

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.updateLabel();
  }

  get doctor(): Doctor {
    return this.authService.getCurrentUser() as Doctor;
  }

  get isValid() {
    return this.validity.biologies && this.validity.radiologies && this.validity.medics;
  }

  get tabIndex(): number {
    return this._tabIndex;
  }

  @Input()
  set tabIndex(value: number) {
    this._tabIndex = value;
    this.updateLabel();
    this.tabChange.emit({ index: this._tabIndex, label: this.label });
    this._onChange();
  }

  onValidityChange(validity: Partial<PrescriptionFormValidity>): void {
    this.validity = {
      medics: validity.medics === undefined ? this.validity.medics : validity.medics,
      biologies: validity.biologies === undefined ? this.validity.biologies : validity.biologies,
      radiologies: validity.radiologies === undefined ? this.validity.radiologies : validity.radiologies
    };
  }

  updateLabel(): void {
    this.label =
      this.tabIndex === 0 ? 'Medicaments' :
      this.tabIndex === 1 ? 'Biologies' :
      'Radiologies';
  }

  _onChange(): void {
    this.updateLabel();
    this.prescriptionChange.emit(this.prescription);
  }

  toggleModels(): void {
    this.open = !this.open;
    this.openChange.emit(this.open);
  }

  changeTab(index: number): void {
    this.tabIndex = index;
  }
}